<template>
  <a-modal style="text-align: center;min-width: 900px;" v-model:visible="props.visible" :title="user.buildName"
           @ok="handleOk" :footer="null" @cancel="emit('showMap',false)">
    <div style="display: flex;flex-direction: row-reverse;margin-bottom: 20px;">
      <a-button type="primary" @click="exportToExcel">导出excel</a-button>
    </div>
    <a-table :columns="columns" :data-source="parkAllDev" bordered :loading="loading" :pagination="myPagination">
      <template #bodyCell="{ column ,text }">
        <template v-if="column.key === 'sim'">
          <template v-if="text.length !== 0">
            <p v-for="(item,index) in text" :key="index">卡{{ index + 1 }}：{{ item }}</p>
          </template>
          <template v-else>{{ text[0] }}</template>
        </template>
        <template v-if="column.key === 'oldPage'">
          <u style="color: rgb(12, 22, 234);cursor: pointer;" @click="openOldMenu(text)">{{ text }}</u>
        </template>
        <template v-if="column.key === 'newPage'">
          <u style="color: rgb(12, 22, 234);cursor: pointer;" @click="openCurrentMenu(text)">{{ text }}</u>
        </template>
      </template>
    </a-table>
  </a-modal>
</template>
<script setup>
import {onMounted, ref} from "vue";
import {axiosPost} from "@/layouts/admin-sidebar/requstDev";
import userStore from "@/stores/user";
import api from "@/service/api";
import load from "@/common/load"
import singleDev from "@/stores/singleDev";
import {exportExcel} from "@/utils";

let user = userStore();
let single = singleDev();

const columns = [
  {
    title: '所属楼层',
    dataIndex: 'floorId',
    align: 'center'
  }, {
    title: '设备Id',
    dataIndex: 'deviceId',
    align: 'center'
  },
  {
    title: '设备二维码',
    dataIndex: 'uniqueCode',
    align: 'center'
  },
  {
    title: '跳转老设备网页',
    dataIndex: 'uniqueCode',
    align: 'center',
    key: 'oldPage'
  },
  {
    title: '跳转当前网页',
    dataIndex: 'uniqueCode',
    align: 'center',
    key: 'newPage'
  },
  {
    title: 'sim',
    dataIndex: 'sim',
    key: 'sim',
    align: 'center'
  }];
let myPagination = {
  defaultPageSize: 7
}
let parkAllDev = ref([]);
let loading = ref(true);
let openCurrentMenu = (code)=>{
  single.changeCurrentCode(code);
  handleOk();
}
let openOldMenu = (code)=>{
  window.open(`http://cn.beefindtech.cn/subservice/mqtt_new/gos8.html?${code}`)
}
// 导出excel
let exportToExcel = ()=>{
  let head = ['设备Id','设备二维码','楼层Id','sim'];
  let data = [];
  parkAllDev.value.forEach(item => {
    if(item.sim.length > 1){
      let str = '';
      for (let i = 0; i < item.sim.length; i++) {
        str += item.sim[i]+';\n'
      }
      data.push([item.deviceId,item.uniqueCode,item.floorId,str])
    }else{
      data.push([item.deviceId,item.uniqueCode,item.floorId,item.sim[0]])
    }

  });
  // let data = [head,ids,codes,floors,sims];
  exportExcel([head,...data],head,`${user.buildName}sim卡号.xlsx`)
  console.log(parkAllDev.value)
}
onMounted(async () => {
  parkAllDev.value = [];
  let res = await axiosPost(api.getSimList, {
    "buildId": user.buildId,
  });
  loading.value = false;
  if (res.result != '1') {
    return load.error(res.msg);
  }
  parkAllDev.value = res.data.filter(item => {
    return item.uniqueCode != null && item.uniqueCode !== '0'
  })
})

let props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
})
let emit = defineEmits(['showMap'])
const handleOk = () => {
  emit('showMap', false);
};
</script>
<style scoped lang="scss">

</style>
